
import Vue from "vue"
import {Component, Prop} from "vue-property-decorator"
import DimensionSelect from "@/ui/DimensionSelect.vue"
import OptionSelect from "@/ui/OptionSelect.vue"
import ByChart from "@/superannuation/ByChart.vue"
import OverTimeChart from "@/superannuation/OverTimeChart.vue"
import {DateRangeSelector} from "@/DateRangeSelector"
import {Dimension, Measure, MemberCube, MemberSnapshotCube} from "@/cube"
import {Option} from "@/ui/Option"
import {measuresAsOptions} from "@/ui/cubeOptions"

@Component({
  components: {ByChart, DimensionSelect, OptionSelect, OverTimeChart},
})
export default class AnalyticsWidget extends Vue {
  @Prop()
  dateRangeSelector: DateRangeSelector

  @Prop({required: true})
  defaultMeasure: string

  @Prop({required: true})
  defaultDimensions: Array<Dimension>

  measure: string = <any>null
  // TODO rgarcia make this a tuple [Dimension,Dimension] or a class to reflect
  //  that it can only hold 2 dimensions instead of being an array - cubejs uses
  // array though
  dimensions: Array<Dimension> = <any>null

  get hasSecondaryDimension() {
    return this.dimensions.length === 2
  }

  measuresAsOptions: ReadonlyArray<Option> = <any>null

  detailOneSecondaryDimension = MemberSnapshotCube.salaryGroup
  detailTwoSecondaryDimension = MemberCube.addressState

  async created() {
    this.measure = this.defaultMeasure
    this.dimensions = this.defaultDimensions
    this.measuresAsOptions = await measuresAsOptions()
  }

  onAddDimension() {
    this.dimensions.push(<any>null)
  }

  onRemoveDimension() {
    this.dimensions.pop()
  }

  select(measure: Measure, dimensions: Array<Dimension> = []) {
    this.measure = measure
    this.dimensions = dimensions
  }
}
